import { styled } from "../../../../styled-components";

export const NewCommentWrapper = styled.button`
    display: flex;
    padding: 0px ${p => p.theme.pageMarginMedium}px;

    align-items: center;
`;

export const AddCommentLabel = styled.div`
    ${p => p.theme.fontStyles.Subheader5}
    margin-left: 10px;

    color: ${p => p.theme.primaryAccentColor};
`;
